import { $isLaunchDarklyInitialized } from "@/stores/launchDarkly"
import { useStore } from "@nanostores/react"
import { type ReactNode } from "react"

export const EnsureLaunchDarklyInitialized = ({
  children,
}: {
  children: ReactNode
}) => {
  const isLaunchDarklyInitialized = useStore($isLaunchDarklyInitialized)

  if (!isLaunchDarklyInitialized) {
    return null
  }

  return <>{children}</>
}
